export enum AwardMarketPriceOption {
    None = 0,
    Latest = 1,
    AwardDate = 2,
}